import { createReducer } from "../../../_common/common";
import {SET_LOGIN_FAILED, SET_USER} from "../actions/constants";


const initialState = {
    authFailed: null,
    loggedUser: null
};

const reducer = createReducer(initialState, {

    [SET_USER]: (state:any, payload:any)=>{
        state.loggedUser = payload;
        state.authFailed = payload === null ? null : false;
        return state
    },

    [SET_LOGIN_FAILED]: (state:any)=>{
        state.loggedUser = false;
        state.authFailed = true;
        return state;
    }



});

export default reducer;
